<template>
  <v-dialog max-width="600px" v-model="dialog">
    <v-card>
      <!-- フォームのタイトル -->
      <v-card-title class="py-5">
        <h2>グループ招待</h2>
      </v-card-title>

      <!-- フォームの内容 -->
      <v-card-text>
        <v-form class="px-3" ref="form">
          <!-- メールアドレス  -->
          <v-text-field
            v-model="email"
            prepend-icon="mdi-email"
            :rules="[rules.required, rules.email]"
            label="メールアドレス"
            @keypress.prevent.enter.exact="enable_submit"
            @keyup.prevent.enter.exact="submit"
          ></v-text-field>
        </v-form>
        <div>
          {{ errorMessage }}
        </div>
      </v-card-text>

      <!-- フォームのアクションボタン -->
      <v-card-actions class="pa-5 pt-0">
        <v-spacer></v-spacer>

        <!-- 実行ボタン -->
        <v-btn
          color="primary"
          rounded
          class="px-5"
          :loading="loading"
          @click="
            enable_submit();
            submit();
          "
          >招待する</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'InvitationGroupMemberDialog',
  props: {
    groupId: Number,
    executeAction: Function,
  },
  data: () => ({
    dialog: false,
    email: '',
    loading: false,
    rules: {
      required: value => !!value || '必須入力です',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || '無効なメールアドレスです';
      },
    },
    errorMessage: null,
    can_submit_search: false,
  }),
  methods: {
    // ダイアログオープン（親コンポーネントから$refs経由で使用する）
    open() {
      this.dialog = true;
    },
    // フォーム初期化
    clear() {
      this.email = '';
      this.errorMessage = null;
      this.$refs.form.resetValidation();
    },
    enable_submit() {
      this.can_submit_search = true;
    },
    // 招待
    submit() {
      if (!this.can_submit_search) return;
      if (this.$refs.form.validate()) {
        this.loading = true;

        this.executeAction({
          email: this.email,
          customer_group_id: this.groupId,
          authority: 0,
        })
          .then(() => {
            this.dialog = false;
          })
          .catch(e => {
            this.errorMessage = e.message;
          })
          .finally(() => {
            this.loading = false;
            this.can_submit_search = false;
          });
      }
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.clear();
      }
    },
  },
};
</script>
